export const contentgridUrl = 'https://contentgrid.homedepot-static.com';
export const imageBaseUrl = 'https://assets.homedepot-static.com/images/v1';
